import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { logError, logEvent } from './analytics';


// Maximum number of users allowed
const MAX_USERS = process.env.REACT_APP_MAX_USER;

/**
 * Always allow location (no restriction)
 * @returns {Promise<boolean>} Always resolves to true
 */
export const isLocationAllowed = () => {
    return Promise.resolve(true);
};

/**
 * Checks if the user limit has been reached
 * @returns {Promise<boolean>} True if user limit has been reached, false otherwise
 */
export const hasUserLimitBeenReached = async () => {
    try {
        const db = getFirestore();
        const usersRef = collection(db, 'users');
        const usersSnapshot = await getDocs(usersRef);

        const userCount = usersSnapshot.size;
        const limitReached = userCount >= MAX_USERS;

        logEvent('user_limit_check', {
            current_users: userCount,
            max_users: MAX_USERS,
            limit_reached: limitReached
        });

        return limitReached;
    } catch (error) {
        logError('accessControl', error);
        return false; // Default to allowing access if check fails
    }
};

/**
 * Checks if a user should be allowed to sign up based on location and user limit
 * @returns {Promise<{allowed: boolean, reason: string}>} Object containing whether access is allowed and the reason
 */
export const showPersistentAccessDeniedToast = (toastRef) => {
  const message = localStorage.getItem('accessDeniedToast');
  if (message && toastRef && toastRef.current) {
    toastRef.current.show({
      severity: 'error',
      summary: 'Access Denied',
      detail: message,
      life: 5000
    });
    localStorage.removeItem('accessDeniedToast');
  }
};

export const checkAccess = async () => {
    // Check if restrictions are enabled
    if (process.env.REACT_APP_RESTRICTED === 'true') {
        const limitReached = await hasUserLimitBeenReached();

        if (limitReached) {
            return {
                allowed: false,
                reason: 'User limit reached.'
            };
        }
    }

    return {
        allowed: true,
        reason: ''
    };
}; 